import {
  AuthenticationResponse,
  AuthenticationRequest,
  ExternalAuthenticateRequest,
  ExternalAuthenticateResponse,
  CurrentInfo,
  Result,
} from "@models";
import { getCurrentLanguage } from "@abp";
import requests from "./agent";

export const authenticationService = {
  authenticate: async (authenticate: AuthenticationRequest) => {
    const response = await requests.post<Result<AuthenticationResponse>>(
      `/api/TokenAuth/Authenticate`,
      authenticate
    );
    return response.result;
  },

  externalAuthenticate: async (request: ExternalAuthenticateRequest) => {
    const response = await requests.post<Result<ExternalAuthenticateResponse>>(
      `/api/TokenAuth/ExternalAuthenticate`,
      request
    );
    return response.result;
  },

  refreshToken: async (refreshToken: string) => {
    const response = await requests.post<Result<AuthenticationResponse>>(
      "/api/TokenAuth/RefreshToken",
      { refreshToken }
    );
    return response.result;
  },

  verifyTurnstileToken: async (token: string | null) => {
    const response = await requests.get<Result<boolean>>(
      `/api/TokenAuth/VerifyTurnstileToken?token=${token}`
    );
    return response.result;
  },

  getCurrentInfo: async () => {
    const response = await requests.get<Result<CurrentInfo>>(
      "/api/services/app/Session/GetCurrentLoginInformations"
    );
    return response.result;
  },

  getAbpUserConfiguration: async () => {
    const culture = getCurrentLanguage();
    const result = await requests.get<any>(
      `/AbpUserConfiguration/GetAll?culture=${encodeURIComponent(culture)}&ui-culture=${encodeURIComponent(culture)}`
    );
    return result.result;
  },
};
